// Comprehensive Cereals, Pulses & Grains Catalogue Data for SPANXPORT

export const grainsData = [
  // === BASMATI RICE ===
  {
    id: "basmati-1121",
    name: "1121 Basmati Rice",
    botanicalName: "Oryza sativa",
    category: "basmati-rice",
    subcategory: "premium",
    image: "basmati-1121",
    description: "1121 Basmati is the longest grain basmati rice variety, known for its exceptional length and aroma. After cooking, grains elongate up to 2.5 times their original length. This premium variety is the most sought-after basmati in international markets.",
    origin: "Punjab, Haryana, Uttar Pradesh - India",
    characteristics: "Extra-long grain, aromatic, non-sticky when cooked, fluffy texture, ages well for enhanced flavor",
    culinaryUses: "Premium biryanis, pulaos, fine dining, Middle Eastern cuisine, luxury retail",
    nutritionalInfo: "Low glycemic index, good source of carbohydrates, gluten-free, contains thiamine",
    specifications: {
      grainLength: "8.30-8.40 mm (raw)",
      elongationRatio: "2.0-2.5x after cooking",
      moisture: "Max 12.5%",
      brokenGrains: "Max 1-2% (Sella), 5% (Raw)",
      foreignMatter: "Max 0.1%",
      ageingPeriod: "12-24 months"
    },
    grades: ["Sella (Parboiled)", "Steam", "Raw/White", "Golden Sella"],
    packaging: "25kg/50kg PP bags, 5kg/10kg retail, bulk",
    shelfLife: "24 months",
    certifications: "APEDA, FSSAI, Non-GMO"
  },
  {
    id: "basmati-1718",
    name: "1718 Basmati Rice",
    botanicalName: "Oryza sativa",
    category: "basmati-rice",
    subcategory: "premium",
    image: "basmati-1718",
    description: "1718 Basmati is a newer premium variety that closely matches 1121 in aroma and cooking characteristics. Slightly shorter grain than 1121 but equally aromatic, making it an excellent value alternative for premium applications.",
    origin: "Punjab, Haryana - India",
    characteristics: "Long grain, strong aroma, excellent elongation, similar cooking style to 1121",
    culinaryUses: "Biryanis, pulaos, everyday premium cooking, restaurant trade, retail",
    nutritionalInfo: "Low GI, gluten-free, good carbohydrate source",
    specifications: {
      grainLength: "8.0-8.2 mm (raw)",
      elongationRatio: "2.0-2.3x after cooking",
      moisture: "Max 12.5%",
      brokenGrains: "Max 2-5%",
      foreignMatter: "Max 0.1%",
      ageingPeriod: "12-18 months"
    },
    grades: ["Sella", "Steam", "Raw/White"],
    packaging: "25kg/50kg bags, retail packs",
    shelfLife: "24 months",
    certifications: "APEDA, FSSAI"
  },
  {
    id: "basmati-1509",
    name: "1509 Basmati Rice",
    botanicalName: "Oryza sativa",
    category: "basmati-rice",
    subcategory: "mid-segment",
    image: "basmati-1509",
    description: "1509 Basmati offers an excellent balance between price and quality. With good aroma and elongation comparable to 1121, it's a popular choice for restaurants and mid-value retailers seeking quality basmati at competitive prices.",
    origin: "Punjab, Haryana, Uttar Pradesh - India",
    characteristics: "Long grain, aromatic, good elongation, lighter grain than 1121",
    culinaryUses: "Restaurant biryanis, everyday cooking, foodservice, mid-range retail",
    nutritionalInfo: "Gluten-free, moderate GI, energy-rich carbohydrates",
    specifications: {
      grainLength: "8.30-8.40 mm (raw)",
      elongationRatio: "2.2-2.7x after cooking",
      moisture: "Max 13%",
      brokenGrains: "Max 3-5%",
      foreignMatter: "Max 0.2%",
      ageingPeriod: "6-12 months"
    },
    grades: ["Sella", "Steam", "Raw"],
    packaging: "25kg/50kg bags, bulk",
    shelfLife: "18-24 months",
    certifications: "APEDA, FSSAI"
  },
  {
    id: "basmati-1401",
    name: "1401 Pusa Basmati Rice",
    botanicalName: "Oryza sativa",
    category: "basmati-rice",
    subcategory: "mid-segment",
    image: "basmati-1401",
    description: "1401 Pusa Basmati has moderate grain length with good aroma, well-suited for bulk exports, catering, and everyday retail packs. It offers consistent quality at an accessible price point.",
    origin: "Punjab, Haryana, Western UP - India",
    characteristics: "Medium-long grain, moderate aroma, good cooking quality",
    culinaryUses: "Bulk catering, institutional cooking, economy retail packs, everyday meals",
    nutritionalInfo: "Gluten-free, good energy source",
    specifications: {
      grainLength: "7.60-7.80 mm (raw)",
      elongationRatio: "1.8-2.2x after cooking",
      moisture: "Max 13%",
      brokenGrains: "Max 5%",
      foreignMatter: "Max 0.2%",
      ageingPeriod: "6-12 months"
    },
    grades: ["Sella", "Steam", "Raw"],
    packaging: "50kg bags, bulk",
    shelfLife: "18 months",
    certifications: "APEDA, FSSAI"
  },
  {
    id: "pusa-basmati",
    name: "Pusa Basmati Rice",
    botanicalName: "Oryza sativa",
    category: "basmati-rice",
    subcategory: "economy",
    image: "pusa-basmati",
    description: "Traditional Pusa Basmati developed by IARI offers good aroma and cooking performance at a lower price point. Popular among economy retail brands and mid-range restaurants seeking authentic basmati character.",
    origin: "North India - Traditional basmati belt",
    characteristics: "Medium grain, traditional basmati aroma, good elongation",
    culinaryUses: "Economy retail, restaurant everyday use, home cooking",
    nutritionalInfo: "Gluten-free, traditional nutritional profile",
    specifications: {
      grainLength: "7.0-7.5 mm (raw)",
      elongationRatio: "1.7-2.0x after cooking",
      moisture: "Max 13%",
      brokenGrains: "Max 5-10%",
      foreignMatter: "Max 0.3%",
      ageingPeriod: "Minimal to 6 months"
    },
    grades: ["Sella", "Steam", "Raw"],
    packaging: "50kg bags, bulk shipments",
    shelfLife: "18 months",
    certifications: "APEDA, FSSAI"
  },
  {
    id: "sugandha-rice",
    name: "Sugandha Rice",
    botanicalName: "Oryza sativa",
    category: "basmati-rice",
    subcategory: "economy",
    image: "sugandha-rice",
    description: "Sugandha is an aromatic rice variety bridging basmati and non-basmati categories. It offers pleasant fragrance at an economical price, making it popular in price-sensitive markets seeking aromatic rice.",
    origin: "Punjab, Haryana - India",
    characteristics: "Medium-long grain, mild aroma, economical",
    culinaryUses: "Budget retail, foodservice, institutional use",
    nutritionalInfo: "Gluten-free, carbohydrate-rich",
    specifications: {
      grainLength: "7.80-8.00 mm (raw)",
      elongationRatio: "1.7-2.2x after cooking",
      moisture: "Max 13%",
      brokenGrains: "Max 5%",
      foreignMatter: "Max 0.3%"
    },
    grades: ["Sella", "Steam", "Raw"],
    packaging: "50kg bags, bulk",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  // === NON-BASMATI RICE ===
  {
    id: "ir64-rice",
    name: "IR 64 Non-Basmati Rice",
    botanicalName: "Oryza sativa",
    category: "non-basmati-rice",
    subcategory: "parboiled",
    image: "ir64-rice",
    description: "IR 64 is a high-yielding, medium-grain rice variety known for its robustness and resistance to pests. With mild, neutral flavor, it's suitable for various cuisines and is one of India's most exported non-basmati varieties.",
    origin: "Andhra Pradesh, Tamil Nadu, West Bengal - India",
    characteristics: "Medium grain, high yield, pest resistant, neutral flavor",
    culinaryUses: "Daily consumption, African markets, institutional feeding, foodservice",
    nutritionalInfo: "Good source of carbohydrates, iron fortification available",
    specifications: {
      grainLength: "6.0-6.5 mm (raw)",
      grainType: "Medium, slender",
      moisture: "Max 14%",
      brokenGrains: "5-25% (various grades)",
      foreignMatter: "Max 0.5%",
      chalkyGrains: "Max 5%"
    },
    grades: ["5% Broken", "10% Broken", "15% Broken", "25% Broken", "100% Broken"],
    packaging: "25kg/50kg PP bags, bulk",
    shelfLife: "24 months",
    certifications: "FSSAI"
  },
  {
    id: "sona-masoori",
    name: "Sona Masoori Rice",
    botanicalName: "Oryza sativa",
    category: "non-basmati-rice",
    subcategory: "premium-non-basmati",
    image: "sona-masoori",
    description: "Sona Masoori is a lightweight, aromatic medium-grain rice popular in South India. Its name means 'golden' (Sona) and 'soft' (Masoori). Low in starch and calories compared to other varieties, it's increasingly popular for health-conscious consumers.",
    origin: "Andhra Pradesh, Telangana, Karnataka - India",
    characteristics: "Medium grain, lightweight, mildly aromatic, low starch",
    culinaryUses: "South Indian cuisine, everyday meals, health-conscious cooking, diabetic-friendly diets",
    nutritionalInfo: "Lower calories than basmati, low starch, light on digestion",
    specifications: {
      grainLength: "5.0-5.5 mm (raw)",
      grainType: "Medium, round-oval",
      moisture: "Max 13%",
      brokenGrains: "Max 2-5%",
      foreignMatter: "Max 0.2%"
    },
    grades: ["Premium", "Standard", "Old crop"],
    packaging: "25kg/50kg bags, retail packs",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  {
    id: "ponni-rice",
    name: "Ponni Rice",
    botanicalName: "Oryza sativa",
    category: "non-basmati-rice",
    subcategory: "premium-non-basmati",
    image: "ponni-rice",
    description: "Ponni rice is a traditional South Indian variety known for its soft texture when cooked. Available in raw and parboiled forms, it's a staple in Tamil Nadu households and increasingly popular in export markets.",
    origin: "Tamil Nadu, Karnataka - India",
    characteristics: "Medium-long grain, soft texture, mild aroma",
    culinaryUses: "South Indian meals, idli/dosa when combined with urad dal, everyday cooking",
    nutritionalInfo: "Good carbohydrate source, iron content in parboiled variety",
    specifications: {
      grainLength: "5.5-6.0 mm (raw)",
      grainType: "Medium, slightly curved",
      moisture: "Max 13%",
      brokenGrains: "Max 3-5%",
      foreignMatter: "Max 0.2%"
    },
    grades: ["BPT (Bhavani Ponni)", "ADT", "CO varieties"],
    packaging: "25kg/50kg bags",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  {
    id: "kolam-rice",
    name: "Kolam Rice",
    botanicalName: "Oryza sativa",
    category: "non-basmati-rice",
    subcategory: "regional",
    image: "kolam-rice",
    description: "Kolam is a medium-grain, spongy rice variety from Maharashtra with mild aroma and economical pricing. Popular as a West and Central India staple, it absorbs flavors well and is preferred for everyday meals.",
    origin: "Maharashtra, Gujarat - India",
    characteristics: "Medium grain, spongy texture, mild aroma, absorbs flavors well",
    culinaryUses: "Daily meals, khichdi, pulao, regional Western Indian cuisine",
    nutritionalInfo: "Standard rice nutrition, good energy source",
    specifications: {
      grainLength: "5.0-5.5 mm (raw)",
      grainType: "Medium, spongy",
      moisture: "Max 13%",
      brokenGrains: "Max 5%",
      foreignMatter: "Max 0.3%"
    },
    grades: ["Raw", "Steam"],
    packaging: "25kg/50kg bags",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  {
    id: "swarna-rice",
    name: "Swarna Rice",
    botanicalName: "Oryza sativa",
    category: "non-basmati-rice",
    subcategory: "parboiled",
    image: "swarna-rice",
    description: "Swarna is one of India's most widely grown rice varieties, cultivated across multiple states. A non-aromatic staple variety, it's known for high yield and adaptability. Popular in Eastern India and for export to African markets.",
    origin: "West Bengal, Bihar, Odisha, Assam - India",
    characteristics: "Medium grain, high yield, non-aromatic, versatile",
    culinaryUses: "Daily staple, institutional feeding, bulk consumption markets",
    nutritionalInfo: "High carbohydrate, iron fortification available",
    specifications: {
      grainLength: "5.0-5.5 mm (raw)",
      grainType: "Medium, compact",
      moisture: "Max 14%",
      brokenGrains: "5-25% (various grades)",
      foreignMatter: "Max 0.5%"
    },
    grades: ["5% Broken", "15% Broken", "25% Broken"],
    packaging: "50kg bags, bulk",
    shelfLife: "24 months",
    certifications: "FSSAI"
  },
  // === SPECIALTY RICE ===
  {
    id: "kalanamak-rice",
    name: "Kalanamak Rice (GI Tagged)",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "heritage",
    image: "kalanamak-rice",
    description: "Kalanamak is an ancient aromatic rice variety from the foothills of Nepal in Uttar Pradesh. With a distinctive black husk and exceptional aroma, it's GI-tagged and commands premium prices. Known as the 'Buddha rice' for its historical significance.",
    origin: "Eastern Uttar Pradesh - India (GI Tagged)",
    characteristics: "Black husk, highly aromatic, unique flavor profile, heritage variety",
    culinaryUses: "Premium preparations, specialty restaurants, gourmet cooking, heritage cuisine",
    nutritionalInfo: "Rich in micronutrients, antioxidants from black bran",
    specifications: {
      grainLength: "5.0-5.5 mm (raw)",
      grainType: "Short-medium, black husk",
      moisture: "Max 12%",
      brokenGrains: "Max 3%",
      aroma: "Strong, distinctive"
    },
    grades: ["Premium", "Standard"],
    packaging: "Retail packs, premium packaging",
    shelfLife: "18 months",
    certifications: "GI Tag, FSSAI, Organic available"
  },
  {
    id: "gobindobhog-rice",
    name: "Gobindobhog Rice",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "heritage",
    image: "gobindobhog-rice",
    description: "Gobindobhog is a premium short-grain aromatic rice from Bengal, traditionally used for religious offerings and festive dishes. Its natural sweetness and exceptional aroma make it prized for payesh (rice pudding) and special occasions.",
    origin: "West Bengal - India",
    characteristics: "Short grain, intensely aromatic, naturally sweet, sticky when cooked",
    culinaryUses: "Payesh (rice pudding), kheer, religious offerings, Bengali festive cuisine",
    nutritionalInfo: "Higher in natural sugars, aromatic compounds",
    specifications: {
      grainLength: "4.0-4.5 mm (raw)",
      grainType: "Short, round, sticky",
      moisture: "Max 12%",
      brokenGrains: "Max 2%",
      aroma: "Intense, sweet"
    },
    grades: ["Premium"],
    packaging: "Retail packs, gift packaging",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "ambemohar-rice",
    name: "Ambemohar Rice",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "heritage",
    image: "ambemohar-rice",
    description: "Ambemohar rice gets its name from its mango blossom-like aroma ('Ambe' meaning mango, 'Mohar' meaning blossom). This aromatic short-grain rice from Maharashtra is prized for its unique fragrance that intensifies when cooked. A heritage variety popular in Maharashtrian cuisine.",
    origin: "Maharashtra (Pune, Nagpur region) - India",
    characteristics: "Short grain, mango blossom aroma, slightly sticky, soft texture",
    culinaryUses: "Traditional Maharashtrian dishes, rice preparations, kheer, festive meals",
    nutritionalInfo: "Good carbohydrate source, aromatic compounds, gluten-free",
    specifications: {
      grainLength: "4.5-5.0 mm (raw)",
      grainType: "Short, aromatic",
      moisture: "Max 13%",
      brokenGrains: "Max 3%",
      aroma: "Distinctive mango blossom"
    },
    grades: ["Premium", "Standard"],
    packaging: "5kg/10kg retail packs, bulk",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "joha-rice",
    name: "Joha Rice (Assamese Aromatic)",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "heritage",
    image: "joha-rice",
    description: "Joha rice is a special class of scented rice indigenous to Assam with over 100 known varieties. Known for its distinctive fragrance and rich taste, it's traditionally served during Assamese festivals and special occasions. The rice has a unique aroma that develops during cooking.",
    origin: "Assam, Northeast India",
    characteristics: "Small grain, intensely aromatic, sticky texture, unique flavor",
    culinaryUses: "Assamese traditional meals, festive dishes, payesh, special occasions",
    nutritionalInfo: "High in dietary fiber, aromatic compounds, gluten-free",
    specifications: {
      grainLength: "4.0-5.0 mm (raw)",
      grainType: "Short, scented",
      moisture: "Max 12%",
      brokenGrains: "Max 2%",
      aroma: "Strong, distinctive Assamese fragrance"
    },
    grades: ["Kola Joha", "Bokul Joha", "Kon Joha"],
    packaging: "Retail packs, premium packaging",
    shelfLife: "12 months",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "pokkali-rice",
    name: "Pokkali Rice (GI Tagged Organic)",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "organic",
    image: "pokkali-rice",
    description: "Pokkali is an ancient salt-tolerant rice variety cultivated in the coastal waterlogged areas of Kerala for over 3000 years. Also called 'Clever Man's Rice', it's grown organically in a unique rice-prawn rotation system. GI-tagged for its distinct characteristics and sustainable farming method.",
    origin: "Kerala (Alappuzha, Ernakulam, Thrissur) - India (GI Tagged)",
    characteristics: "Red-brown grain, salt-tolerant, naturally organic, unique taste",
    culinaryUses: "Traditional Kerala cuisine, healthy diet preparations, specialty restaurants",
    nutritionalInfo: "High fiber, rich in minerals, low glycemic index, naturally organic",
    specifications: {
      grainLength: "5.5-6.0 mm (raw)",
      grainType: "Medium, red-brown",
      moisture: "Max 12%",
      brokenGrains: "Max 3%",
      farmingMethod: "Organic rice-prawn rotation"
    },
    grades: ["Organic Premium"],
    packaging: "2kg/5kg retail packs",
    shelfLife: "12 months",
    certifications: "GI Tag, Organic Certified, FSSAI"
  },
  {
    id: "navara-rice",
    name: "Navara Rice (Ayurvedic Rice)",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "medicinal",
    image: "navara-rice",
    description: "Navara is an ancient medicinal rice variety from Kerala, known as 'the rice that cures'. Used extensively in Ayurvedic treatments, particularly Navarakizhi (a therapeutic massage using rice boluses). It's a low-yield, 60-day crop making it expensive but highly valued for therapeutic properties.",
    origin: "Kerala (Palakkad, Malappuram) - India",
    characteristics: "Small red grain, medicinal properties, quick maturity (60 days)",
    culinaryUses: "Ayurvedic treatments, Navarakizhi therapy, medicinal porridge, health foods",
    nutritionalInfo: "Rich in iron, easily digestible, therapeutic properties, low GI",
    specifications: {
      grainLength: "4.0-4.5 mm (raw)",
      grainType: "Short, red, medicinal",
      moisture: "Max 12%",
      brokenGrains: "Max 2%",
      cropDuration: "60 days (short duration)"
    },
    grades: ["Medicinal Grade", "Food Grade"],
    packaging: "1kg/2kg medicinal packs, retail",
    shelfLife: "12 months",
    certifications: "FSSAI, Ayush certified available"
  },
  {
    id: "palakkadan-matta",
    name: "Palakkadan Matta Rice (GI Tagged)",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "parboiled-red",
    image: "palakkadan-matta",
    description: "Palakkadan Matta, also called Rosematta or Kerala Red Rice, is a GI-tagged parboiled rice from Palakkad district. Its distinctive red color comes from the bran layer retained during processing. Known for its earthy flavor and health benefits, it's a staple in Kerala cuisine.",
    origin: "Palakkad, Kerala - India (GI Tagged)",
    characteristics: "Red parboiled, high fiber, earthy flavor, firm texture when cooked",
    culinaryUses: "Kerala meals, puttu, appam, idiyappam, traditional South Indian cuisine",
    nutritionalInfo: "High fiber, iron-rich, low GI, retains bran nutrients",
    specifications: {
      grainLength: "5.5-6.5 mm (raw)",
      grainType: "Medium, red parboiled",
      moisture: "Max 13%",
      brokenGrains: "Max 5%",
      processing: "Parboiled with bran intact"
    },
    grades: ["Double Polished", "Single Polished", "Unpolished"],
    packaging: "5kg/10kg/25kg bags",
    shelfLife: "18 months",
    certifications: "GI Tag, FSSAI"
  },
  {
    id: "indrayani-rice",
    name: "Indrayani Rice",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "regional",
    image: "indrayani-rice",
    description: "Indrayani is a premium aromatic rice variety from Maharashtra, named after the Indrayani river. Known for its pleasant fragrance and soft texture, it's a popular choice for everyday meals in Western India. The rice has a distinctive taste that sets it apart from other regional varieties.",
    origin: "Maharashtra (Indrayani river belt) - India",
    characteristics: "Medium grain, mildly aromatic, soft texture, easy to cook",
    culinaryUses: "Daily meals, pulao, khichdi, Maharashtrian cuisine",
    nutritionalInfo: "Good carbohydrate source, easy to digest, gluten-free",
    specifications: {
      grainLength: "5.5-6.0 mm (raw)",
      grainType: "Medium, aromatic",
      moisture: "Max 13%",
      brokenGrains: "Max 3%",
      aroma: "Mild, pleasant"
    },
    grades: ["Premium", "Standard"],
    packaging: "5kg/10kg/25kg bags",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "jeerakasala-rice",
    name: "Jeerakasala Rice (Wayanadan)",
    botanicalName: "Oryza sativa",
    category: "specialty-rice",
    subcategory: "heritage",
    image: "jeerakasala-rice",
    description: "Jeerakasala, also known as Kaima or Biryani Rice, is a short-grain aromatic rice from Kerala's Wayanad district. Its name comes from its cumin seed-like appearance. Highly prized for biryani preparation due to its non-sticky nature and ability to absorb flavors while remaining fluffy.",
    origin: "Wayanad, Kerala - India",
    characteristics: "Short grain, cumin-shaped, aromatic, non-sticky, absorbs flavors well",
    culinaryUses: "Malabar biryani, Thalassery biryani, special rice preparations, festive dishes",
    nutritionalInfo: "Rich in carbohydrates, aromatic compounds, gluten-free",
    specifications: {
      grainLength: "4.0-4.5 mm (raw)",
      grainType: "Short, cumin-shaped",
      moisture: "Max 12%",
      brokenGrains: "Max 2%",
      aroma: "Strong, distinctive"
    },
    grades: ["Wayanadan Premium", "Standard"],
    packaging: "1kg/5kg retail packs",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  // === WHEAT ===
  {
    id: "durum-wheat",
    name: "Durum Wheat",
    botanicalName: "Triticum durum",
    category: "wheat",
    subcategory: "hard-wheat",
    image: "durum-wheat",
    description: "Durum wheat is the hardest of all wheats, with high protein and gluten content. Its amber-colored semolina is essential for pasta production. India exports significant quantities to pasta-manufacturing countries.",
    origin: "Madhya Pradesh, Rajasthan, Gujarat - India",
    characteristics: "Hard kernel, amber color, high protein, high gluten",
    culinaryUses: "Pasta, semolina, couscous, bulgur, Mediterranean breads",
    nutritionalInfo: "High protein (12-15%), high gluten, B vitamins, iron",
    specifications: {
      protein: "12-15%",
      moisture: "Max 12%",
      testWeight: "Min 78 kg/hl",
      foreignMatter: "Max 1%",
      vitreousKernels: "Min 60%"
    },
    grades: ["Grade 1", "Grade 2", "Feed Grade"],
    packaging: "50kg PP bags, bulk",
    shelfLife: "12 months",
    certifications: "FSSAI, Non-GMO"
  },
  {
    id: "wheat-grain",
    name: "Wheat (Bread Wheat)",
    botanicalName: "Triticum aestivum",
    category: "wheat",
    subcategory: "common-wheat",
    image: "wheat-grain",
    description: "Common bread wheat is India's primary wheat variety, used for chapati, bread, and general flour production. India is a major wheat producer and exports to neighboring countries and Africa.",
    origin: "Punjab, Haryana, MP, UP, Rajasthan - India",
    characteristics: "Medium-hard kernel, versatile, good gluten development",
    culinaryUses: "Flour for bread, chapati, roti, biscuits, general baking",
    nutritionalInfo: "Protein 10-12%, carbohydrates, fiber, B vitamins",
    specifications: {
      protein: "10-12%",
      moisture: "Max 12%",
      testWeight: "Min 76 kg/hl",
      foreignMatter: "Max 1%",
      damagedKernels: "Max 2%"
    },
    grades: ["FAQ (Fair Average Quality)", "Mill Quality"],
    packaging: "50kg PP bags, bulk",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  // === PULSES ===
  {
    id: "chickpeas-kabuli",
    name: "Kabuli Chickpeas (Chole)",
    botanicalName: "Cicer arietinum",
    category: "pulses",
    subcategory: "chickpeas",
    image: "chickpeas-kabuli",
    description: "Kabuli chickpeas are large, cream-colored legumes with a smooth coat. Popular worldwide for hummus, salads, and curries. India produces and exports significant quantities of various size grades.",
    origin: "Madhya Pradesh, Rajasthan, Maharashtra - India",
    characteristics: "Large, cream-white, smooth coat, nutty flavor",
    culinaryUses: "Hummus, falafel, chana masala, salads, Mediterranean cuisine",
    nutritionalInfo: "High protein (20-22%), fiber, folate, iron, phosphorus",
    specifications: {
      size: "7mm, 8mm, 9mm, 10mm+",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%",
      damagedGrains: "Max 2%",
      splitGrains: "Max 2%"
    },
    grades: ["42/44 count", "44/46 count", "58/60 count"],
    packaging: "25kg/50kg PP bags",
    shelfLife: "18 months",
    certifications: "FSSAI, Non-GMO"
  },
  {
    id: "chickpeas-desi",
    name: "Desi Chickpeas (Chana)",
    botanicalName: "Cicer arietinum",
    category: "pulses",
    subcategory: "chickpeas",
    image: "chickpeas-desi",
    description: "Desi chickpeas are smaller with a rougher coat and darker color ranging from tan to black. They have a nuttier flavor than Kabuli and are the primary chickpea used in Indian cuisine and for making besan flour.",
    origin: "Central and Western India",
    characteristics: "Small, rough coat, tan to dark brown, nutty flavor",
    culinaryUses: "Besan flour, Indian curries, snacks, chana dal",
    nutritionalInfo: "Higher fiber than Kabuli, protein 18-20%, iron rich",
    specifications: {
      size: "5-7mm",
      moisture: "Max 12%",
      foreignMatter: "Max 1%",
      damagedGrains: "Max 3%"
    },
    grades: ["Bold", "Medium", "Small"],
    packaging: "50kg PP bags, bulk",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  {
    id: "red-lentils",
    name: "Red Lentils (Masoor Dal)",
    botanicalName: "Lens culinaris",
    category: "pulses",
    subcategory: "lentils",
    image: "red-lentils",
    description: "Red lentils are split and hulled lentils with a distinctive salmon-pink to orange color. They cook quickly and break down into a creamy consistency, making them ideal for dal, soups, and stews.",
    origin: "Madhya Pradesh, Uttar Pradesh, Bihar - India",
    characteristics: "Split, hulled, salmon-pink color, quick cooking, creamy texture",
    culinaryUses: "Dal preparations, soups, stews, Middle Eastern cuisine, baby food",
    nutritionalInfo: "Protein 24-26%, high in iron, folate, fiber",
    specifications: {
      type: "Split, dehusked",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%",
      brokenGrains: "Max 3%",
      color: "Uniform salmon-orange"
    },
    grades: ["Bold", "Medium", "Small"],
    packaging: "25kg/50kg bags",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  {
    id: "pigeon-peas",
    name: "Pigeon Peas (Toor/Arhar Dal)",
    botanicalName: "Cajanus cajan",
    category: "pulses",
    subcategory: "tropical-pulses",
    image: "pigeon-peas",
    description: "Pigeon peas, known as Toor or Arhar dal in India, are a staple pulse with earthy, nutty flavor. Available whole or split (dal), they're essential for South Indian sambar and North Indian dal preparations.",
    origin: "Maharashtra, Karnataka, Madhya Pradesh - India",
    characteristics: "Yellow color, earthy flavor, versatile cooking",
    culinaryUses: "Sambar, dal fry, dal tadka, Caribbean rice and peas",
    nutritionalInfo: "Protein 20-22%, high fiber, iron, potassium",
    specifications: {
      type: "Split, polished/unpolished",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%",
      damagedGrains: "Max 2%"
    },
    grades: ["Polished", "Unpolished", "Oily"],
    packaging: "25kg/50kg bags",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "mung-beans",
    name: "Mung Beans (Green Gram)",
    botanicalName: "Vigna radiata",
    category: "pulses",
    subcategory: "beans",
    image: "mung-beans",
    description: "Mung beans are small, green legumes widely used in Asian cuisine. Available whole, split (moong dal), or sprouted. They're easily digestible and popular for their versatility in sweet and savory dishes.",
    origin: "Rajasthan, Maharashtra, Andhra Pradesh - India",
    characteristics: "Small, green, easily digestible, versatile",
    culinaryUses: "Dal, sprouts, desserts (moong dal halwa), Asian stir-fries, soups",
    nutritionalInfo: "Protein 24%, easy to digest, rich in folate, magnesium",
    specifications: {
      type: "Whole/Split/Washed",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%",
      damagedGrains: "Max 2%"
    },
    grades: ["Bold", "Medium", "FAQ"],
    packaging: "25kg/50kg bags",
    shelfLife: "18 months",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "black-gram",
    name: "Black Gram (Urad Dal)",
    botanicalName: "Vigna mungo",
    category: "pulses",
    subcategory: "beans",
    image: "black-gram",
    description: "Black gram, or urad dal, is essential for South Indian cuisine. Its unique mucilaginous property makes it indispensable for idli, dosa, and vada. Available whole (black) or split (white inside).",
    origin: "Andhra Pradesh, Maharashtra, Madhya Pradesh - India",
    characteristics: "Black skin, white interior, creamy, slightly mucilaginous",
    culinaryUses: "Idli, dosa batter, vada, dal makhani, papad",
    nutritionalInfo: "Protein 25%, iron, calcium, very high in fiber",
    specifications: {
      type: "Whole/Split (with skin/without skin)",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%",
      damagedGrains: "Max 2%"
    },
    grades: ["Bold", "Medium"],
    packaging: "25kg/50kg bags",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "kidney-beans",
    name: "Kidney Beans (Rajma)",
    botanicalName: "Phaseolus vulgaris",
    category: "pulses",
    subcategory: "beans",
    image: "kidney-beans",
    description: "Kidney beans are large, kidney-shaped beans available in red, light speckled (chitra), and white varieties. A North Indian favorite in rajma chawal, they're also popular worldwide for chili and bean salads.",
    origin: "Jammu & Kashmir, Himachal Pradesh, Uttarakhand - India",
    characteristics: "Large, kidney-shaped, meaty texture, absorbs flavors well",
    culinaryUses: "Rajma curry, chili con carne, bean salads, soups",
    nutritionalInfo: "Protein 22-24%, high fiber, iron, potassium",
    specifications: {
      type: "Red/Chitra/White",
      size: "Large",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%"
    },
    grades: ["Red Kidney", "Chitra (Speckled)", "White"],
    packaging: "25kg/50kg bags",
    shelfLife: "18 months",
    certifications: "FSSAI"
  },
  // === MILLETS ===
  {
    id: "pearl-millet",
    name: "Pearl Millet (Bajra)",
    botanicalName: "Pennisetum glaucum",
    category: "millets",
    subcategory: "major-millet",
    image: "pearl-millet",
    description: "Pearl millet, called Bajra in India, is a highly nutritious grain grown in arid regions. It's a staple in Rajasthan and Gujarat, used for rotis and porridge. Gaining popularity as a superfood for its nutritional profile.",
    origin: "Rajasthan, Gujarat, Haryana, Maharashtra - India",
    characteristics: "Small, round, gray-white, slightly nutty flavor",
    culinaryUses: "Bajra roti, khichdi, porridge, malted drinks, flour",
    nutritionalInfo: "High in iron, protein, fiber, gluten-free, low GI",
    specifications: {
      moisture: "Max 12%",
      foreignMatter: "Max 1%",
      damagedGrains: "Max 2%",
      color: "Gray to brownish"
    },
    grades: ["Bold", "Medium", "FAQ"],
    packaging: "50kg bags, retail packs",
    shelfLife: "12 months",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "finger-millet",
    name: "Finger Millet (Ragi)",
    botanicalName: "Eleusine coracana",
    category: "millets",
    subcategory: "major-millet",
    image: "finger-millet",
    description: "Finger millet, known as Ragi, is a highly nutritious grain rich in calcium. It's a staple in Karnataka and parts of Africa. Increasingly popular globally as a health food for its exceptional mineral content.",
    origin: "Karnataka, Tamil Nadu, Andhra Pradesh, Uttarakhand - India",
    characteristics: "Small, reddish-brown, high calcium, earthy flavor",
    culinaryUses: "Ragi mudde, ragi dosa, porridge, baby food, malt beverages",
    nutritionalInfo: "Highest calcium among cereals, iron, amino acids, gluten-free",
    specifications: {
      moisture: "Max 12%",
      foreignMatter: "Max 1%",
      damagedGrains: "Max 2%",
      color: "Reddish-brown"
    },
    grades: ["Bold", "Medium"],
    packaging: "50kg bags, retail packs",
    shelfLife: "12 months",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "sorghum",
    name: "Sorghum (Jowar)",
    botanicalName: "Sorghum bicolor",
    category: "millets",
    subcategory: "major-millet",
    image: "sorghum",
    description: "Sorghum, called Jowar in India, is a drought-resistant grain used for food and animal feed. It's a staple in Maharashtra and Karnataka. Available in white and red varieties, it's gluten-free and nutritious.",
    origin: "Maharashtra, Karnataka, Madhya Pradesh - India",
    characteristics: "Round grains, white or red, mild sweet flavor",
    culinaryUses: "Jowar roti, bhakri, porridge, popped jowar, animal feed",
    nutritionalInfo: "Protein 10%, fiber, antioxidants, gluten-free",
    specifications: {
      type: "White/Red",
      moisture: "Max 12%",
      foreignMatter: "Max 1%",
      damagedGrains: "Max 2%"
    },
    grades: ["White Sorghum", "Red Sorghum", "Feed Grade"],
    packaging: "50kg bags, bulk",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "foxtail-millet",
    name: "Foxtail Millet (Kangni)",
    botanicalName: "Setaria italica",
    category: "millets",
    subcategory: "small-millet",
    image: "foxtail-millet",
    description: "Foxtail millet is a small-seeded millet with yellow color, popular in India and East Asia. It's one of the oldest cultivated millets, valued for its balanced nutrition and easy digestibility.",
    origin: "Andhra Pradesh, Karnataka, Tamil Nadu - India",
    characteristics: "Small, yellow grains, slightly sweet, easy to digest",
    culinaryUses: "Rice substitute, upma, kheer, millet bowls",
    nutritionalInfo: "High in dietary fiber, iron, calcium, gluten-free",
    specifications: {
      moisture: "Max 12%",
      foreignMatter: "Max 1%",
      hulledGrains: "Min 95%",
      color: "Yellow"
    },
    grades: ["Hulled", "Unhulled"],
    packaging: "25kg bags, retail packs",
    shelfLife: "12 months",
    certifications: "FSSAI, Organic available"
  },
  // === OTHER GRAINS ===
  {
    id: "maize-corn",
    name: "Yellow Maize (Corn)",
    botanicalName: "Zea mays",
    category: "cereals",
    subcategory: "corn",
    image: "maize-corn",
    description: "Yellow maize is a versatile grain used for food, feed, and industrial purposes. India exports significant quantities for poultry feed and starch production. Available in food grade and feed grade.",
    origin: "Karnataka, Andhra Pradesh, Bihar, Madhya Pradesh - India",
    characteristics: "Yellow kernels, starchy, versatile applications",
    culinaryUses: "Cornmeal, tortillas, popcorn, animal feed, starch production",
    nutritionalInfo: "Carbohydrates, fiber, vitamins A and B",
    specifications: {
      moisture: "Max 14%",
      foreignMatter: "Max 2%",
      brokenGrains: "Max 3%",
      aflatoxin: "Max 20 ppb"
    },
    grades: ["Food Grade", "Feed Grade", "Popcorn"],
    packaging: "50kg bags, bulk",
    shelfLife: "12 months",
    certifications: "FSSAI, Non-GMO"
  },
  {
    id: "barley",
    name: "Barley",
    botanicalName: "Hordeum vulgare",
    category: "cereals",
    subcategory: "ancient-grain",
    image: "barley",
    description: "Barley is an ancient grain used for food, malt, and animal feed. Pearl barley (hulled and polished) is popular for soups and stews. India produces both food-grade and malting barley.",
    origin: "Rajasthan, Uttar Pradesh, Madhya Pradesh - India",
    characteristics: "Chewy texture, nutty flavor, versatile",
    culinaryUses: "Soups, stews, salads, barley water, malt for brewing",
    nutritionalInfo: "High in beta-glucan fiber, protein, B vitamins",
    specifications: {
      moisture: "Max 12%",
      foreignMatter: "Max 1%",
      protein: "10-12%",
      germinationRate: "Min 95% (malting)"
    },
    grades: ["Pearl Barley", "Pot Barley", "Malting Grade", "Feed Grade"],
    packaging: "50kg bags",
    shelfLife: "12 months",
    certifications: "FSSAI"
  },
  {
    id: "quinoa",
    name: "Quinoa",
    botanicalName: "Chenopodium quinoa",
    category: "cereals",
    subcategory: "superfood",
    image: "quinoa",
    description: "Quinoa, though a pseudo-cereal, is nutritionally superior with complete protein. India has started cultivating quinoa to meet domestic and export demand. Available in white, red, and black varieties.",
    origin: "Andhra Pradesh, Rajasthan - India (New cultivation)",
    characteristics: "Small round seeds, complete protein, gluten-free",
    culinaryUses: "Salads, bowls, rice substitute, breakfast porridge",
    nutritionalInfo: "Complete protein with all 9 essential amino acids, high fiber",
    specifications: {
      type: "White/Red/Black/Tricolor",
      moisture: "Max 12%",
      foreignMatter: "Max 0.5%",
      protein: "12-16%"
    },
    grades: ["Organic", "Conventional"],
    packaging: "25kg bags, retail packs",
    shelfLife: "24 months",
    certifications: "FSSAI, Organic available"
  }
];

// Get all unique categories
export const grainCategories = [...new Set(grainsData.map(g => g.category))];

// Get grain by ID
export const getGrainById = (id) => grainsData.find(g => g.id === id);

// Get grains by category
export const getGrainsByCategory = (category) => grainsData.filter(g => g.category === category);

// Category labels
export const grainCategoryLabels = {
  "basmati-rice": "Basmati Rice",
  "non-basmati-rice": "Non-Basmati Rice",
  "specialty-rice": "Specialty/Heritage Rice",
  "wheat": "Wheat",
  "pulses": "Pulses & Lentils",
  "millets": "Millets",
  "cereals": "Other Cereals"
};
